import request from '../utils/request';
import hex_md5 from '../utils/md5';
import { REST_SERVICE } from '../config';

// const unifiedService = {
//   //token验证
//   getAccessToken: function(data) {
//     return request({
//       url: REST_SERVICE.unified.getAccessToken,
//       method: 'post',
//       data
//     });
//   }
// };
const unifiedService = {
  // md5加密
  md5(value) {
    return hex_md5(value);
  },
  //token验证
  getAccessToken: function (data) {
    return request({
      url: window.CONFIG.UNIFIED_ACCESSTOKEN,
      method: 'post',
      data
    });
  },
  //登出
  logout: function (params) {
    return request({
      url: window.UNIFIED_LOGOUT,
      method: 'get',
      params
    });
  }
};

export default unifiedService;
